import React from 'react';

import { Skeleton } from '@/components/ui/skeleton';

import { cn } from '@/lib/utils';

export function HomePageSkeleton() {
	return (
		<div className="h-full w-full overflow-y-auto px-0 focus-within:outline-none md:px-0">
			<div className="ml-auto mr-auto flex h-[100%] w-[100%] max-w-[760px] flex-1 flex-col">
				{/* Header Section */}
				<div className="mb-4 mt-9 flex items-center justify-between gap-4 px-4 md:mb-8 md:px-6">
					<Skeleton className="h-8 w-16" />
					<div className="flex items-center gap-2">
						<Skeleton className="h-9 w-24" />
						<Skeleton className="h-9 w-16" />
					</div>
				</div>

				{/* Form Cards List */}
				<HomeCardsSkeleton />
			</div>
		</div>
	);
}

export function HomeCardsSkeleton() {
	return (
		<div className="flex flex-col">
			{Array.from({ length: 6 }).map((_, index) => (
				<div
					key={index}
					className={cn(
						'shadow-none',
						'hover:bg-muted/50',
						'w-full rounded-lg border-0 border-border-light'
					)}
				>
					<div className="flex p-4 md:p-6">
						{/* Form Thumbnail */}
						<div className="mr-3 h-12 w-[72px] flex-shrink-0 overflow-hidden rounded-md border border-white md:mr-6 md:h-16 md:w-24">
							<Skeleton className="h-full w-full" />
						</div>

						{/* Form Content */}
						<div className="min-w-0 flex-1">
							{/* Form Title */}
							<div className="mb-2 md:mb-3">
								<Skeleton className="h-5 w-48 md:h-6 md:w-56" />
							</div>

							{/* Applications Count */}
							<div className="flex items-center gap-2">
								<Skeleton className="h-4 w-20" />
							</div>
						</div>

						{/* More Options Button */}
						<div className="flex items-start pl-4">
							<Skeleton className="h-9 w-9 rounded" />
						</div>
					</div>
				</div>
			))}
		</div>
	);
}
